import { render, staticRenderFns } from "./ModulesLinks.vue?vue&type=template&id=7d5db1c6"
import script from "./ModulesLinks.vue?vue&type=script&lang=js"
export * from "./ModulesLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BasicLink: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/basic/BasicLink.vue').default})
